module.exports = __webpack_public_path__ + "img/koho_hledame.f65d0e18.jpg";